// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useEffect, useRef } from 'react';

/**
 * A ref that reads true until this component unmounts.
 *
 * For continuations that run from a hook-level mutation callback (so they
 * still fire after the component that started them is gone) and mix durable
 * work with presentation side effects — closing a modal, navigating, patching
 * the URL. The durable part must run unconditionally; the presentation part
 * should check this first, since acting on a stale router/state handle after
 * unmount can still mutate something that outlives the component (history).
 */
export function useIsMounted() {
  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );
  return mounted;
}
